import React from "react";
import "./index.css";

export function Logo({ className = "" }) {
  return (
    <div className={`logo-container ${className}`}>
      <img src="/images/logo.png" alt="Game Logo" className="game-logo" />
    </div>
  );
}

